export enum ElementType {
  Text,
  TextCode,
  TextHide,
  TextShowLast,
  TextMoveTo,
  TextMoveFrom,
  NewLine,
  OptionFail,
  OptionPass,
}

export type IQuiz = Array<{
  type: ElementType;
  data: string | ICode;
}>;

export type ICode = Array<{
  text?: string;
  isNewLine?: boolean;
  marginLeft?: string;
  color?: string;
}>;

export interface IThink {
  quizIndex: number;
  thinkTexts: string[];
  hintTexts: string[];
}
